<div [className]="promptClass" [ngClass]="{'danger-hide-close': hideClose}">
  <div [className]="iconBackground">
    <mat-icon [className]="iconClass"></mat-icon>
  </div>
  <div class="message">{{message}}</div>
  <div *ngIf="!hideClose" class="close"><span class="sif sif-close" (click)="onClose()"></span></div>
</div>
